import styled from 'styled-components'

export const BaseWrapper = styled.div<{
  $flexDirection?: 'column' | 'row'
  $maxHeight?: string
  $height?: string
  $padding?: string
  $justifyLeftContent?: string
  $width?: string
}>`
  display: flex;
  flex-direction: ${({ $flexDirection }) => $flexDirection || 'row'};
  flex: 1;
  max-height: ${({ $maxHeight }) => $maxHeight || '100%'};
  height: ${({ $height }) => $height || 'auto'};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    flex-direction: column;
    align-items: flex-start;
    width: ${({ $width }) => $width || '80vw'};
    max-height: 75vh;
  }
`

export const ChildrenOptions = styled.div`
  flex: 1;
  overflow-x: hidden;
  overflow-y: scroll;
`

export const ChildrenOption = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.padding(2)} ${({ theme }) => theme.padding(2)};
  cursor: pointer;

  &:not(:last-child)::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    display: block;
    margin-left: ${({ theme }) => theme.padding(2)};
    border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey};
    width: 100%;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.lightGrey};

    &:last-child {
      border-bottom-left-radius: ${({ theme }) => theme.borderRadius};
      border-bottom-right-radius: ${({ theme }) => theme.borderRadius};
    }
  }

  &.is-selected,
  &.is-selected:hover {
    background-color: ${({ theme }) => theme.colors.lightGrey};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const ItemLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`

export const Left = styled.div<{
  $justifyLeftContent?: string
}>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: ${({ $justifyLeftContent }) => $justifyLeftContent || 'flex-start'};
`

export const Title = styled.div`
  font-weight: bold;

  svg {
    color: ${({ theme }) => theme.colors.primary};
  }
`

export const Right = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    margin-top: ${({ theme }) => theme.padding(2)};
    justify-content: flex-start;
  }
`

export const Alert = styled.div`
  padding: ${({ theme }) => theme.padding(1)} ${({ theme }) => theme.padding(2)};
  border-radius: ${({ theme }) => theme.borderRadius};
  margin-right: ${({ theme }) => theme.padding(1)};
  text-transform: uppercase;
  font-weight: bold;
  max-width: 200px;
  text-align: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    width: 100%;
    max-width: none;
  }
`

export const Button = styled.button`
  user-select: none;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.lightGrey};
  padding: ${({ theme }) => theme.padding(1)} ${({ theme }) => theme.padding(2)};
  border-radius: ${({ theme }) => theme.borderRadius};
  margin-right: ${({ theme }) => theme.padding(1)};
  border: none;
  white-space: nowrap;
`

export const Cards = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
`

export const Card = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.padding(2)} ${({ theme }) => theme.padding(2)};
  cursor: pointer;

  @media (min-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    &[data-selected='true'] {
      background-color: ${({ theme }) => theme.colors.lightGrey};
    }
  }

  &:not(:last-child)::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    display: block;
    margin-left: ${({ theme }) => theme.padding(2)};
    border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey};
    width: 100%;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.lightGrey};

    &:last-child {
      border-bottom-left-radius: ${({ theme }) => theme.borderRadius};
      border-bottom-right-radius: ${({ theme }) => theme.borderRadius};
    }
  }
`

export const WrapperButtons = styled.div`
  display: flex;
  padding: 10px;
  justify-content: flex-end;
  width: 100%;
  gap: ${({ theme }) => theme.padding(1)};
  align-items: center;
`

export const LastButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export interface ArticleItemsProps {
  $isLoading: boolean
}

export const ArticleItems = styled(BaseWrapper).attrs<ArticleItemsProps>(({ $isLoading }) => ({
  $flexDirection: 'column',
}))<ArticleItemsProps>`
  ${({ $isLoading }) => ($isLoading ? 'cursor: wait;' : 'cursor: pointer;')}
  width: 100%;
`
